import styled from 'styled-components';
import { P, theme } from '@ovotech/element-v5';
import { breakpoints } from '@/src/utils/mediaQuery';

export const RowContainer = styled.div`
  display: grid;
  align-items: center;
  column-gap: ${theme.space[400]};
  row-gap: ${theme.space[300]};
  grid-template-columns: auto 1fr auto auto;
  grid-template-areas: 'icon details amount view';

  /* TODO: Confirm mobile design with Josh. For now we say that on phones the View link drops underneath the details/badge instead of
  being squashed in line with the amount. */
  @media ${breakpoints.smallDown} {
    grid-template-columns: auto 1fr auto;
    grid-template-areas:
      'icon details amount'
      '.    view    .';
  }
`;

export const FuelIcon = styled.div`
  grid-area: icon;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${theme.color.neutral[20]};
`;

export const TransactionDetails = styled.div`
  grid-area: details;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.space[100]};
  min-width: 0;
`;

export const TransactionDate = styled(P)`
  color: ${theme.color.surface.onSurfaceVariant};
`;

export const AmountColumn = styled.div`
  grid-area: amount;
  justify-self: end;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const Amount = styled(P)`
  white-space: nowrap;
  font-size: ${theme.font.size.xl.mediaQuery.lg};

  @media ${breakpoints.smallDown} {
    font-size: ${theme.font.size.xl.mediaQuery.sm};
  }
`;

export const TopupType = styled(TransactionDate)`
  font-size: ${theme.font.size.sm.mediaQuery.lg};
  text-align: right;
  width: min-content;
`;

export const ViewLink = styled.div`
  grid-area: view;
  justify-self: end;

  @media ${breakpoints.smallDown} {
    justify-self: start;
  }
`;
